import { createRouter, createWebHistory } from 'vue-router'
import UserLogin from './components/UserLogin.vue'
import MainLayout from './components/MainLayout.vue'
import ClientMainLayout from './components/ClientMainLayout.vue'
import UserManagement from './components/views/UserManagement.vue'
import RoleManagement from './components/views/RoleManagement.vue'
import Settings from './components/views/ParmSettings.vue'
import GatewayManager from './components/views/GatewayManager.vue'
import TemplateManagement from './components/views/TemplateManagement.vue'
import DeviceManagement from './components/views/DeviceManagement.vue'
import ParentComponent from './components/views/ParentComponent.vue'
import construction from './components/views/UnderConstruction.vue'
import RealTimePlot from './components/views/RealTimePlot.vue'
import RealTimeData from './components/views/RealTimeData.vue'
import DashboardView from './components/views/DashboardView.vue'
import OrganizationManagement from './components/views/OrganizationManagement.vue'
import HistoryRecord from './components/views/HistoryRecord.vue'
import Table from './components/views/ScrollTable.vue'
import OperationLog from './components/views/OperationLog.vue'
import ClientAccount from './components/clientViews/ClientAccount.vue'
import ClientMessage from './components/clientViews/clientMessage.vue'
import ClientProjectDeail from './components/views/ClientProjectDeail.vue'
import ClientProjectDeailAdd from './components/views/ClientProjectDeailAdd.vue'
import ClientDeviceDeail from './components/views/ClientProjectDeail.vue'
import ClientDeivceMonitor from './components/views/ClientDeviceMonitor.vue'
import RtuStatusView from './components/clientViews/rtu/RtuStatusView.vue'
import RtuFleetDashboard from './components/clientViews/rtu/RtuFleetDashboard.vue'
import { isRtuUser, isRouteAllowedForRtuUser } from './utils/roles'

const routes = [
      {
        path: '/',
        redirect: '/UserLogin'
      },
      {
        path: '/UserLogin',
        name: 'UserLoginPage',
        component: UserLogin
      },
      {
        path: '/clientMain',
        component: ClientMainLayout,
        meta: { requiresAuth: true },
        children: [     
          {
          path: 'clientDeivceMonitor', // 注意：这里没有斜杠
          name: 'ClientDeivceMonitorPage',
          component: ClientDeivceMonitor,
          meta: { title: '设备监控' }
        },
          {
          path: 'clientDeviceDeail', // 注意：这里没有斜杠
          name: 'ClientDeviceDeailPage',
          component: ClientDeviceDeail,
          meta: { title: '设置列表' }
        },
        {
          path: 'messages', // 注意：这里应该是 messages（复数）
          name: 'ClientMessagePage',
          component: ClientMessage,
          meta: { title: '消息中心' }
        },
        {
          path: 'accounts',
          name: 'clientAccountPage',
          component: ClientAccount,
          meta: { title: '账号管理' }
        },
        {
          path: 'rtuStatus',
          name: 'RtuStatusPage',
          component: RtuStatusView,
          meta: { title: 'RTU状态' }
        },
        {
          path: 'rtuDashboard',
          name: 'RtuFleetDashboardPage',
          component: RtuFleetDashboard,
          meta: { title: 'RTU概览' }
        },
        // 默认重定向
        {
          path: '',
          redirect: 'settings'
        }
    ]
  },
  {
    path: '/main',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'DashboardPage',
        component: DashboardView
      },
      {
        path: 'users',
        name: 'UserManagementPage',
        component: UserManagement
      },
      {
        path: 'roles',
        name: 'RoleManagementPage',
        component: RoleManagement
      },      
      {
        path: 'settings',
        name: 'SettingsPage',
        component: Settings
      },
      {
        path: 'gateways',
        name: 'GatewayManagerPage',
        component: GatewayManager
      },
      {
        path: 'templates',
        name: 'TemplateManagementPage',
        component: TemplateManagement
      },
      {
        path: 'devices',
        name: 'DeviceManagementPage',
        component: DeviceManagement
      },
      {
        path: 'parent',
        name: 'ParentComponentPage',
        component: ParentComponent
      },
      {
        path: 'realtimeplot',
        name: 'RealTimePlotPage',
        component: RealTimePlot
      },
      {
        path: 'realTimeData',
        name: 'realTimeDataPage',
        component: RealTimeData
      },
      {
        path: 'historyRecord',
        name: 'historyRecordPage',
        component: HistoryRecord
      },      
      {
        path: 'organization',
        name: 'organizationPage',
        component: OrganizationManagement
      },
      {
        path: 'operationLog',
        name: 'operationLogPage',
        component: OperationLog
      },      
      {
          path: 'clientProjectDeail', // 注意：这里没有斜杠
          name: 'ClientProjectDeailPage',
          component: ClientProjectDeail,      
      },
      {
          path: 'clientProjectDeailAdd', // 注意：这里没有斜杠
          name: 'ClientProjectDeailAddPage',
          component: ClientProjectDeailAdd,      
      },
      {
        path: 'construction',
        name: 'ConstructionPage',
        component: construction
      },      
      {
        path: 'table',
        name: 'TablePage',
        component: Table
      },      
      // 默认重定向到dashboard
      {
        path: '',
        redirect: 'dashboard'
      }
    ]
  },
  // 404页面
  {
    path: '/:pathMatch(.*)*',
    redirect: '/UserLogin'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
// router/index.js
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('authToken')

  if (to.path !== '/UserLogin' && !token) {
    next('/UserLogin')
    return
  }

  // RTU User 角色路由白名单（深链/手输 URL 一律弹回；服务端另有 403 兜底）
  if (to.path !== '/UserLogin' && isRtuUser() && !isRouteAllowedForRtuUser(to.path)) {
    next('/clientMain/rtuDashboard')
    return
  }

  next()
})

// 路由守卫
// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (!localStorage.getItem('token')) {
//       next({
//         path: '/UserLogin',
//         query: { redirect: to.fullPath }
//       })
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
// })

export default router